import "../styles/Maps.css";
import MapCreator from "../components/MapCreator";
import MapTemplateCreator from "../components/MapTemplateCreator";
import {useSearchParams} from "react-router-dom";
import MapEditor from "./MapEditor";
import MapTemplateEditor from "./MapTemplateEditor";
import MapTemplateList from "../components/MapTemplateList";
import PersonalMapList from "../components/PersonalMapList";
import MapRenderer from "./MapRenderer";
import useAxiosRequest from "../hooks/useAxiosRequest";
import config from "../config.json";
import MapViewer from "./MapViewer";

const Maps = () => {
    const [ searchParams ] = useSearchParams();

    const { isLoading, error } = useAxiosRequest({
        url: `${config.backendUrl}/user`,
        withCredentials: true,
        method: "get"
    });

    if (searchParams.has("render")) return <MapRenderer id={searchParams.get("render")}/>

    if (searchParams.has("view")) return <MapViewer id={searchParams.get("view")}/>

    if (isLoading) return;

    if (error) return window.location = '/';

    if (searchParams.has("edit")) return <MapEditor id={searchParams.get("edit")}/>

    if (searchParams.has("editTemplate")) return <MapTemplateEditor id={searchParams.get("editTemplate")}/>

    return (
        <div id="content">
            <div id="upper-content">
                <div className="spacer"></div>
                <MapTemplateCreator/>
                <MapCreator/>
                <div className="spacer"></div>
            </div>
            <div id="lower-content">
                <MapTemplateList/>
                <PersonalMapList/>
            </div>
        </div>
    );
}

export default Maps;
